import contenteditableTypes from '../constants/contenteditable-types';

export default function isContenteditableDisabled(constraint) {
  return (
    !!constraint.contenteditable && constraint.contenteditable === contenteditableTypes.DISABLED
  );
}
